import { DisputeCategory } from './disputeCatalogs.dto';
import { Customer } from './../../../app/core/models/customer.model';
import { Jobsite } from '../../../app/core/models/jobsite.model';
import { DisputeStatus } from './disputeCatalogs.dto';

interface Attachment {}

export interface Dispute {
    categoryCode: string; // categoryCode (category)
    categoryDesc: string;
    channelCode: string;
    commitmentDate: string;
    contact: string;
    countInvoices: number;
    customerCode: string;
    customerDesc: string;
    dateOfLastChange: string;
    director: string;
    disputeAmount: string;
    disputeBalance: string;
    disputeCode: number;
    disputeDate: string;
    date?: Date;
    disputeId: number;
    disputeStatusCode: string; // disputeStatusCode (status)
    disputeStatusDesc: string;
    guid: string;
    jobSiteCode: string;
    jobSiteDesc: string;
    plantDesc: string;
    lastComment: string;
    requestedAmount?: string;
    managerName: string;
    marketDesc: string;
    regionDesc: string;
    responsibleUserName: string;
    salesAreaCode: string;
    salesOfficeCode: string;
    salesOrgCode: string;
    sectorCode: string;
    salesRepName: string;
    segment: string;
    segmentDesc: string;
    zoneDesc: string;
    attachmentCount?: number;
    attachments?: Array<Attachment>;
    disputeCategory?: DisputeCategory;
    customer?: Customer;
    jobSite?: Jobsite;
    status?: DisputeStatus;
}

export interface DisputesDTO {
    disputes: Array<Dispute>;
}
